import React, { SyntheticEvent, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { appEnv } from '../../_env';
import { cleanSearch } from '../../_shared/queryString';
import { useIsLogged } from '../../user/hooks';
import { LoginRequestModal } from '../components/LoginRequestModal';

export function useLoginRequest({
   defaultShow,
   title,
   description,
   search,
}: {
   defaultShow?: boolean;
   title?: string;
   description?: string;
   search?: string;
}) {
   const { userLoading, isLogged } = useIsLogged();

   const { pathname } = useLocation();

   const [showLoginRequestModal, setShowLoginRequestModal] = useState(defaultShow);

   const doLogin = useCallback(() => {
      window.location.href = `${appEnv.appDomains.login}/login?return_to=${
         appEnv.appDomains.loginReturnTo + pathname
      }${cleanSearch(search)}`;
   }, [pathname, search]);

   const LoginModal = useCallback(() => {
      return showLoginRequestModal ? (
         <LoginRequestModal
            title={title}
            description={description}
            onLogin={doLogin}
            onCancel={() => {
               setShowLoginRequestModal(false);
            }}
         />
      ) : null;
   }, [showLoginRequestModal, setShowLoginRequestModal, title, description, doLogin]);

   const showLoginModal = useCallback(
      (e?: SyntheticEvent) => {
         e?.preventDefault();
         setShowLoginRequestModal(true);
      },
      [setShowLoginRequestModal],
   );

   const hideLoginModal = useCallback(
      (e?: SyntheticEvent) => {
         e?.preventDefault();
         setShowLoginRequestModal(false);
      },
      [setShowLoginRequestModal],
   );

   return {
      userLoading,
      isLogged,
      LoginModal,
      showLoginModal,
      hideLoginModal,
      doLogin,
   };
}
